import { AnswerDto } from "./../dto/answer-dto";
import { UrlParametersModel } from "./../model/url-parameters-model";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ClozeTestService {
  readonly #httpClient = inject(HttpClient);
  readonly insertSpecialCharacterToInput$$ = new Subject<string>();
  readonly removeLastCharacter$$ = new Subject<string>();

  public inputNumber = 0;

  public getTest(url: string, urlParameters?: UrlParametersModel) {
    if (urlParameters) {
      url = this.buildGetUrl(url, urlParameters);
    }
    return this.#httpClient.post(url, null);
  }

  public getNextTest(
    url: string,
    buchungId: number,
    spracheId: number,
    start_level: number,
    end_level: number,
    variante: number
  ) {
    url += `?`;
    url += `&buchungId=${buchungId}`;
    url += `&start_level=${start_level}`;
    url += `&end_level=${end_level}`;
    url += `&spracheId=${spracheId}`;
    url += `&varianteId=${variante}`;
    return this.#httpClient.post(url, null);
  }

  public postTest(url: string, test: AnswerDto[]) {
    return this.#httpClient.post(url, test, { responseType: "text" });
  }

  public getResults(url: string, buchungId: number, urlParameters?: UrlParametersModel, frontEndLanguageId?: number) {
    if (urlParameters) {
      url = this.buildResultUrl(url, urlParameters, frontEndLanguageId);
    }
    url += `&buchungId=${buchungId}`;
    return this.#httpClient.get(url);
  }

  public updateStartTimeOfAnExercise(url: string, buchungId: number, aufgabeId: number) {
    url = `${url}api/aufgabe/start-time?booking-id=${buchungId}&aufgabe-id=${aufgabeId}`;
    this.#httpClient.post(url, null).subscribe(
      (response) => {
        // Handle the success response
        console.log("Start time updated successfully:", response);
      },
      (error) => {
        // Handle the error response
        console.error("Error updating start time:", error);
      }
    );
  }

  public updateEndTimeOfAnExercise(url: string, buchungId: number, aufgabeId: number) {
    url = `${url}api/aufgabe/end-time?booking-id=${buchungId}&aufgabe-id=${aufgabeId}`;
    this.#httpClient.post(url, null).subscribe(
      (response) => {
        // Handle the success response
        console.log("End time updated successfully:", response);
      },
      (error) => {
        // Handle the error response
        console.error("Error updating end time:", error);
      }
    );
  }

  public updateBrowserRefreshCountOfTest(url: string, buchungId: number) {
    url = `${url}api/booking/browser-refresh?booking-id=${buchungId}`;
    this.#httpClient.post(url, null).subscribe(
      (response) => {
        // Handle the success response
        console.log("browser-refresh successfully:", response);
      },
      (error) => {
        // Handle the error response
        console.error("Error updating browser-refresh:", error);
      }
    );
  }

  public updateResultShownTimeOfTest(url: string, buchungId: number) {
    url = `${url}api/booking/result-shown-time?booking-id=${buchungId}`;
    this.#httpClient.post(url, null).subscribe(
      (response) => {
        // Handle the success response
        console.log("result-shown-time updated successfully:", response);
      },
      (error) => {
        // Handle the error response
        console.error("Error updating result-shown-time:", error);
      }
    );
  }

  public setActiveInputNumber(nr: number) {
    this.inputNumber = nr;
  }

  public setSpecialCharacterToInput(specialCharacter: string) {
    this.insertSpecialCharacterToInput$$.next(specialCharacter);
  }

  public removeLastCharacterFromInput() {
    this.removeLastCharacter$$.next("");
  }

  private buildGetUrl(url: string, urlParameters: UrlParametersModel): string {
    return (
      `${url}?geburtsdatum=${urlParameters.geburtsdatum}&herkunft=${urlParameters.herkunft}&geschlecht=${urlParameters.geschlecht}&` +
      `variante=${urlParameters.variante}&sprache=${urlParameters.sprache}&testzentrum=${urlParameters.testzentrum}&tool=${urlParameters.tool}` +
      `&start_level=${urlParameters.start_level}&end_level=${urlParameters.end_level}`
    );
  }

  private buildGetNextUrl(url: string, urlParameters: UrlParametersModel): string {
    return (
      `${url}?geburtsdatum=${urlParameters.geburtsdatum}&herkunft=${urlParameters.herkunft}&geschlecht=${urlParameters.geschlecht}&` +
      `variante=${urlParameters.variante}&sprache=${urlParameters.sprache}&testzentrum=${urlParameters.testzentrum}&tool=${urlParameters.tool}` +
      `&start_level=${urlParameters.start_level}&end_level=${urlParameters.end_level}`
    );
  }

  private buildResultUrl(url: string, urlParameters: UrlParametersModel, frontEndLanguageId?: number): string {
    if (frontEndLanguageId) {
      return `${url}?varianteId=${urlParameters.variante}&start_level=${urlParameters.start_level}&end_level=${urlParameters.end_level}&sprache=${frontEndLanguageId}`;
    } else {
      return `${url}?varianteId=${urlParameters.variante}&start_level=${urlParameters.start_level}&end_level=${urlParameters.end_level}`;
    }
  }
}
